// extracted by mini-css-extract-plugin
export default {"container":"LoadComponent_container__NdcRc","content":"LoadComponent_content__7WkU8"};